export const GrayDeleteIcon = () => (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.5714 10.8571H10.5"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.2148 8.99988H18.8577"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.642 10.8571V21.4428C21.642 21.5905 21.5822 21.7322 21.4758 21.8367C21.3694 21.9412 21.2251 21.9999 21.0746 21.9999H11.9952C11.8447 21.9999 11.7004 21.9412 11.5939 21.8367C11.4875 21.7322 11.4277 21.5905 11.4277 21.4428V10.8571"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
